import { render, staticRenderFns } from "./ViewCategories.vue?vue&type=template&id=60ce5b83&"
import script from "./ViewCategories.vue?vue&type=script&lang=js&"
export * from "./ViewCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports